import MaintenanceCountdown from "@/components/maintenance/MaintenanceCountDown.vue";
export default {
  name: "MaintenancePage",
  components: {
    MaintenanceCountdown: MaintenanceCountdown
  },
  data: function data() {
    return {};
  },
  methods: {}
};